import React from 'react';
import styled from 'astroturf/react';

import { currentUser } from 'js/utils/user';
import { DisconnectedCanonicalWorkResults as CanonicalWorkResults } from './canonical_work_results';

const Container = styled.div`
  filter: blur(6px);
  grid-column: 2 / 4;
  pointer-events: none;
  width: 100%;
`;

const noop = () => {};

// We just have the minimum required dummy data here
// to get the component to render
const work = {
  id: 1,
  internalUrl: '',
  authors: [
    {
      id: 1,
      url: '',
      displayName: 'Richard Price',
    },
  ],
  downloadableAttachments: [],
  metadata: {
    abstract:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi at posuere diam, eget malesuada sapien. Nulla tincidunt risus in diam porta gravida. Nunc quis posuere turpis, non blandit magna. Vestibulum vestibulum non enim ut interdum. Maecenas hendrerit id augue ac vehicula. Suspendisse sit amet vulputate elit.',
  },
  researchInterests: [],
  title: 'Open Access Meets Discoverability',
};
const works = [work, work, work, work, work];

const BlurredResults = () => {
  return (
    <Container>
      <CanonicalWorkResults
        actors={{}}
        addToLibrary={noop}
        fetchActorData={noop}
        fetchResearchInterestFollowerCount={noop}
        followResearchInterest={noop}
        followUser={noop}
        loadWorkShareSuggestions={noop}
        premium={Boolean(currentUser?.premium)}
        removeFromLibrary={noop}
        reportWork={noop}
        requestJoinSession={noop}
        researchInterests={{}}
        unfollowResearchInterest={noop}
        unfollowUser={noop}
        works={works}
      />
    </Container>
  );
};

export default BlurredResults;
